import { TuiIcon, TuiInput, TuiTextfield, TuiCalendar } from '@taiga-ui/core';
import {
  ChangeDetectionStrategy,
  Component,
  effect,
  inject,
  input,
  OnInit,
} from '@angular/core';
import {
  FormBuilder,
  FormGroupDirective,
  ReactiveFormsModule,
} from '@angular/forms';
import { TuiCopy, TuiInputDate } from '@taiga-ui/kit';
import { TimePickerComponent } from '@core/components/time-picker/time-picker.component';
import { HyphenedStringTuiDateTransformerDirective } from '@core/directives/hyphenedStringTuiDateTransformer.directive';
import { RequestFormCommonSupplierActualReleaseDateComponent } from './components/request-form-common-supplier-actual-release-date/request-form-common-supplier-actual-release-date.component';
import { RequestDTO } from '@core/types/Request';
import { RequestService } from '@core/services/request/request.service';
import { TranslatePipe } from '@ngx-translate/core';

enum FormFields {
  DeliveryName = 'deliveryName',
  DeliveryAddress = 'deliveryAddress',
  DeliveryPersonName = 'deliveryPersonName',
  DeliveryPersonPhone = 'deliveryPersonPhone',
  DeliveryPersonEmail = 'deliveryPersonEmail',
  ReleaseDate = 'releaseDate',
  ReleaseTime = 'releaseTime',
}

type FormType = Pick<
  RequestDTO,
  | 'deliveryName'
  | 'deliveryAddress'
  | 'deliveryPersonEmail'
  | 'deliveryPersonName'
  | 'deliveryPersonPhone'
  | 'releaseDate'
  | 'releaseTime'
>;

@Component({
  selector: 'x-request-form-common-supplier',
  imports: [
    TuiTextfield,
    TuiCalendar,
    ReactiveFormsModule,
    TuiInput,
    TuiInputDate,
    TimePickerComponent,
    TuiIcon,
    TuiCopy,
    HyphenedStringTuiDateTransformerDirective,
    RequestFormCommonSupplierActualReleaseDateComponent,
    TranslatePipe,
  ],
  templateUrl: './request-form-common-supplier.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RequestFormCommonSupplierComponent implements OnInit {
  protected readonly FormFields = FormFields;
  private readonly formBuilder = inject(FormBuilder);
  private readonly parentForm = inject(FormGroupDirective);
  readonly requestService = inject(RequestService);
  protected formGroup = this.formBuilder.group<FormType>({
    [FormFields.DeliveryName]: '',
    [FormFields.DeliveryAddress]: '',
    [FormFields.DeliveryPersonName]: '',
    [FormFields.DeliveryPersonPhone]: '',
    [FormFields.DeliveryPersonEmail]: '',
    [FormFields.ReleaseDate]: undefined,
    [FormFields.ReleaseTime]: undefined,
  });

  $readOnly = input<boolean>(false, { alias: 'readOnly' });

  constructor() {
    effect(() => {
      if (this.$readOnly()) {
        this.formGroup.disable();
      }
    });
  }

  ngOnInit() {
    this.formGroup.patchValue(this.requestService.$request());
    this.parentForm.form.addControl('supplier', this.formGroup);
  }
}
